import { render } from "./ReturnedLeads.vue?vue&type=template&id=538c3919"
import script from "./ReturnedLeads.vue?vue&type=script&lang=js"
export * from "./ReturnedLeads.vue?vue&type=script&lang=js"
script.render = render

export default script